"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = require("./Input");
var _excluded = ["value", "onChange", "format", "popperPlacement", "placeholder", "customInput"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  .react-datepicker {\n    border-color: ", ";\n    font-family: 'Formular', sans-serif !important;\n    &__close-icon {\n      padding-right: 16px;\n      &:after {\n        background-color: transparent;\n        color: ", ";\n        font-size: 18px;\n      }\n      &:hover:after {\n        color: ", ";\n      }\n    }\n    &__navigation-icon:before {\n      border-color: ", ";\n    }\n    &__header {\n      background: ", ";\n    }\n    &__day {\n      &--in-range,\n      &--range-start,\n      &--range-end,\n      &--selecting-range-start,\n      &--selecting-range-end,\n      &--keyboard-selected {\n        background: ", ";\n      }\n      &--in-selecting-range {\n        background: ", ";\n      }\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryShade2;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tertiaryShade2;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondaryShade;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.lightPrimary;
});
var DatePicker = function DatePicker(_ref8) {
  var value = _ref8.value,
    onChange = _ref8.onChange,
    _ref8$format = _ref8.format,
    format = _ref8$format === void 0 ? 'dd.MM.yy' : _ref8$format,
    _ref8$popperPlacement = _ref8.popperPlacement,
    popperPlacement = _ref8$popperPlacement === void 0 ? 'bottom' : _ref8$popperPlacement,
    placeholder = _ref8.placeholder,
    _ref8$customInput = _ref8.customInput,
    CustomInputComponent = _ref8$customInput === void 0 ? /*#__PURE__*/_react.default.createElement(_Input.Input, null) : _ref8$customInput,
    props = _objectWithoutProperties(_ref8, _excluded);
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    selected: value,
    onChange: onChange,
    dateFormat: format,
    placeholderText: placeholder,
    popperPlacement: popperPlacement,
    customInput: /*#__PURE__*/_react.default.createElement(_Input.Input, null)
  }, props)));
};
exports.DatePicker = DatePicker;